import type { UIMessage } from '@tanstack/ai-client';

export default function isHumanMessage(message: UIMessage | undefined): message is UIMessage {
  return message?.role === 'user';
}
